import React from "react";
import { Link } from "react-router-dom";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";
import { ArrowRight } from "lucide-react";

const STEPS = [
  { n: "I", title: "Join the waitlist", body: "We open subscriptions region by region. Tell us your area and we'll let you know the moment your local farms are accepting orders." },
  { n: "II", title: "Choose your box & cadence", body: "Pick your bloom box size (small, medium, large) and how often you'd like one. Weekly, fortnightly, or monthly through the season." },
  { n: "III", title: "Your grower harvests", body: "Each week a local Bloom Club grower hand picks your flowers from their own farm. What's actually blooming where you live." },
  { n: "IV", title: "Delivered, flat laid, unarranged", body: "Your bloom box arrives wrapped in care, ready for you to arrange yourself at home. Part flower delivery, part creative ritual." },
  { n: "V", title: "Live with the season", body: "Through the season your box reflects what the land is offering. Early summer dahlias give way to autumn celosia and beyond." },
];

export default function HowItWorksPage() {
  return (
    <div className="club-theme min-h-screen" data-testid="howitworks-page">
      <PublicHeader />
      <section className="max-w-5xl mx-auto px-6 md:px-12 pt-20 pb-12">
        <div className="bloom-divider mb-6">✦ Chapter I · How it works ✦</div>
        <h1 className="font-serif text-5xl md:text-7xl leading-[0.95] max-w-3xl">From <em>field</em> to your kitchen table.</h1>
        <p className="font-serif italic text-xl text-[var(--bloom-ink-soft)] mt-6 max-w-2xl">
          The Heritage Bloom Club is built on five simple rituals. Here is the season, start to finish.
        </p>
      </section>
      <section className="max-w-5xl mx-auto px-6 md:px-12 pb-20 space-y-12">
        {STEPS.map((s) => (
          <article key={s.n} className="grid grid-cols-1 md:grid-cols-12 gap-6 border-t border-[var(--bloom-border)] pt-10" data-testid={`step-${s.n}`}>
            <div className="md:col-span-2">
              <div className="font-serif italic text-6xl text-[var(--bloom-brand)] leading-none">{s.n}</div>
            </div>
            <div className="md:col-span-10">
              <h2 className="font-serif text-4xl leading-tight mb-3">{s.title}</h2>
              <p className="font-serif text-lg text-[var(--bloom-ink-soft)] leading-[1.85] italic max-w-2xl">{s.body}</p>
            </div>
          </article>
        ))}
        <div className="text-center pt-10">
          <Link to="/waitlist" className="bloom-btn bloom-btn-primary">Join the Waitlist <ArrowRight size={14} /></Link>
        </div>
      </section>
      <PublicFooter />
    </div>
  );
}
